module.exports = __webpack_public_path__ + "img/client10.30f1059c.svg";